import { Routes } from '@angular/router';

import { ROUTE_NAMES } from '@constants';
import { i18nResolver, userBeanResolver } from 'src/app/core/resolvers';
import { roomResolver } from './resolvers/room.resolver';
import { roomsResolver } from './resolvers/rooms.resolver';

export const roomsRoutes: Routes = [
  {
    path: 'rooms',
    title: 'WEB_ROOM_LIST',
    loadComponent: () =>
      import('./pages/rooms.component').then((m) => m.RoomsComponent),
    resolve: {
      userBean: userBeanResolver,
      resource: roomsResolver,
      i18n: i18nResolver,
    },
    data: { navigationRoute: ROUTE_NAMES.ROOMS },
  },
  {
    path: 'rooms/:id',
    title: 'WEB_ROOM_AAA',
    loadComponent: () =>
      import('./pages/room.component').then((m) => m.RoomComponent),
    resolve: {
      userBean: userBeanResolver,
      resource: roomResolver,
      i18n: i18nResolver,
    },
    data: { navigationRoute: ROUTE_NAMES.ROOMS },
  },
];
